import { createContext } from 'react'

const LessonContext = createContext({})

export { LessonContext }